// 具体的な使い方は `/system/users` のユーザ一覧を参照して下さい
document.addEventListener("turbo:load", function () {
  const gon = window.gon || {};
  const q = gon.highlight_search_word_q;
  if (!q) return;

  const escapedQ = q
    .split(/\s+/)
    .map((s) => s.replace(/[.*+?^=!:${}()|[\]/\\]/g, "\\$&"))
    .join("|");

  const re = new RegExp(escapedQ, "ig");
  for (const el of document.querySelectorAll(".cc-highlight-searched-word")) {
    el.innerHTML = el.textContent.replace(
      re,
      "<span class='cc-query-highlight'>$&</span>",
    );
  }
});
